import Container from "react-bootstrap/Container";

import ErrorMessage from "./ErrorMessage";

import { useTranslation } from "react-i18next";

const NoMatchPage = () => {
  const { t } = useTranslation();

  return (
    <Container expand="lg" className="home-page-container">
      <ErrorMessage message={t("404NotFound")} />
    </Container>
  );
};

export default NoMatchPage;
